<form class="grid-container grid-3" [formGroup]="formGroup">
    <ui-form-field class="grid-row-1" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.VALUE' | translate">
        <ui-select
            formControlName="measureCode"
            labelField="name"
            valueField="measureCode"
            [options]="availableMeasures"
            [required]="true"
            [disabled]="!availableMeasures?.length || disabled"
        />
    </ui-form-field>

    <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.SEGMENTATION' | translate">
        <ui-select
            formControlName="segmentationDimensionCode"
            labelField="name"
            valueField="dimensionCode"
            groupField="resourceTypeLabel"
            [options]="segmentationDimensions$ | async"
            [disabled]="!(segmentationDimensions$ | async)?.length || disabled"
            [clearable]="true"
        />
    </ui-form-field>
    <ui-toggle
        formControlName="areDataLabelsActivated"
        class="grid-row-3 toggle"
        [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.LEGEND_DISPLAYED' | translate"
    />
</form>
